// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subSeconds as fn } from "../subSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subSecondsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default subSecondsWithOptions;
